import { httpsCallable } from 'firebase/functions';
import type { DeckIntelligence } from '../types';
import { functions } from './firebase';

const REFINE_CALLABLE_TIMEOUT_MS = 150_000;

export type RefineBusinessOpportunityResponse = {
  ideaIntelligence: DeckIntelligence;
  aiRefinement: string;
};

export function refineBusinessOpportunityErrorMessage(err: unknown): string {
  if (err && typeof err === 'object' && 'message' in err) {
    const message = String((err as { message: string }).message);
    if (message && !message.startsWith('Firebase')) {
      return message;
    }
  }
  if (err && typeof err === 'object' && 'code' in err) {
    const code = String((err as { code: string }).code);
    if (code === 'functions/invalid-argument') {
      return 'Enter a refinement note of at least 10 characters.';
    }
    if (code === 'functions/unauthenticated') {
      return 'Sign in to refine the idea.';
    }
    if (code === 'functions/unavailable') {
      return 'Refinement service is temporarily unavailable. Try again.';
    }
    if (code === 'functions/deadline-exceeded') {
      return 'Refinement timed out. Try again in a moment.';
    }
  }
  return err instanceof Error ? err.message : 'Refinement failed.';
}

export async function refineBusinessOpportunity(
  opportunityId: string,
  note: string
): Promise<RefineBusinessOpportunityResponse> {
  const fn = httpsCallable<
    { opportunityId: string; note: string },
    RefineBusinessOpportunityResponse
  >(functions, 'refineBusinessOpportunity', { timeout: REFINE_CALLABLE_TIMEOUT_MS });
  return (await fn({ opportunityId: opportunityId.trim(), note })).data;
}
